"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useStyles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _GojobLogo = _interopRequireDefault(require("../GojobLogo"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Burger = _interopRequireDefault(require("../Icons/Burger"));

var _Background = _interopRequireDefault(require("./Background"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _TouchableOpacity = _interopRequireDefault(require("../TouchableOpacity"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return (0, _react.useMemo)(function () {
    return {
      root: {
        position: 'relative'
      },
      background: {
        zIndex: 0,
        width: '100%'
      },
      logo: {
        boxSizing: 'border-box',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        height: '100%',
        width: 'auto',
        // Bigger bottom spacing is needed to manage the bottom shadow of the drawer
        padding: spacing(1.5, 0, 3.5, 0),
        color: colors.primary
      },
      content: {
        zIndex: 1,
        position: 'absolute',
        left: spacing(0.5),
        top: spacing(1),
        right: spacing(0.5),
        bottom: spacing(0.5)
      },
      menu: {
        alignSelf: 'baseline',
        minWidth: spacing(4),
        padding: spacing(1)
      }
    };
  }, [spacing, colors]);
};

exports.useStyles = useStyles;

__signature__(useStyles, "useTheme{{ spacing, colors }}\nuseMemo{}", function () {
  return [_useTheme2.default];
});

var MobileHeader = function MobileHeader(props, ref) {
  var children = props.children,
      hideMenu = props.hideMenu,
      onMenuClick = props.onMenuClick,
      BackgroundProps = props.BackgroundProps,
      containerProps = props.containerProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "hideMenu", "onMenuClick", "BackgroundProps", "containerProps"]);
  var classes = useStyles();
  return (0, _core.jsx)("header", (0, _extends2.default)({
    css: classes.root
  }, other, {
    ref: ref
  }), (0, _core.jsx)(_Background.default, (0, _extends2.default)({
    css: classes.background
  }, BackgroundProps)), (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    justifyContent: "flex-end",
    css: classes.content
  }, containerProps), children !== null && children !== void 0 ? children : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_GojobLogo.default, {
    "data-testid": "Logo",
    css: classes.logo
  }), (0, _core.jsx)(_Fade.default, {
    in: !hideMenu
  }, (0, _core.jsx)(_TouchableOpacity.default, {
    css: classes.menu,
    "data-testid": "Menu",
    onClick: onMenuClick
  }, (0, _core.jsx)(_Icon.default, {
    as: _Burger.default,
    color: "primary",
    size: 6
  }))))));
};

__signature__(MobileHeader, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(MobileHeader);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
  reactHotLoader.register(MobileHeader, "MobileHeader", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Nb2JpbGVIZWFkZXIvaW5kZXgudHN4Il0sIm5hbWVzIjpbInVzZVN0eWxlcyIsInNwYWNpbmciLCJjb2xvcnMiLCJyb290IiwicG9zaXRpb24iLCJiYWNrZ3JvdW5kIiwiekluZGV4Iiwid2lkdGgiLCJsb2dvIiwiYm94U2l6aW5nIiwibGVmdCIsInRvcCIsInRyYW5zZm9ybSIsImhlaWdodCIsInBhZGRpbmciLCJjb2xvciIsInByaW1hcnkiLCJjb250ZW50IiwicmlnaHQiLCJib3R0b20iLCJtZW51IiwiYWxpZ25TZWxmIiwibWluV2lkdGgiLCJ1c2VUaGVtZSIsIk1vYmlsZUhlYWRlciIsInByb3BzIiwicmVmIiwiY2hpbGRyZW4iLCJoaWRlTWVudSIsIm9uTWVudUNsaWNrIiwiQmFja2dyb3VuZFByb3BzIiwiY29udGFpbmVyUHJvcHMiLCJvdGhlciIsImNsYXNzZXMiLCJCdXJnZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUVBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUVBOztBQUNBOzs7Ozs7Ozs7Ozs7O0FBU08sSUFBTUEsU0FBUyxHQUFHLFNBQVpBLFNBQVksR0FBTTtBQUFBLGtCQUNELHlCQURDO0FBQUEsTUFDckJDLE9BRHFCLGFBQ3JCQSxPQURxQjtBQUFBLE1BQ1pDLE1BRFksYUFDWkEsTUFEWTs7QUFFN0IsU0FBTyxvQkFDTDtBQUFBLFdBQ0c7QUFDQ0MsTUFBQUEsSUFBSSxFQUFFO0FBQ0pDLFFBQUFBLFFBQVEsRUFBRTtBQUROLE9BRFA7QUFJQ0MsTUFBQUEsVUFBVSxFQUFFO0FBQ1ZDLFFBQUFBLE1BQU0sRUFBRSxDQURFO0FBRVZDLFFBQUFBLEtBQUssRUFBRTtBQUZHLE9BSmI7QUFRQ0MsTUFBQUEsSUFBSSxFQUFFO0FBQ0pDLFFBQUFBLFNBQVMsRUFBRSxZQURQO0FBRUpMLFFBQUFBLFFBQVEsRUFBRSxVQUZOO0FBR0pNLFFBQUFBLElBQUksRUFBRSxLQUhGO0FBSUpDLFFBQUFBLEdBQUcsRUFBRSxLQUpEO0FBS0pDLFFBQUFBLFNBQVMsRUFBRSx1QkFMUDtBQU1KQyxRQUFBQSxNQUFNLEVBQUUsTUFOSjtBQU9KTixRQUFBQSxLQUFLLEVBQUUsTUFQSDtBQVFKO0FBQ0FPLFFBQUFBLE9BQU8sRUFBRWIsT0FBTyxDQUFDLEdBQUQsRUFBTSxDQUFOLEVBQVMsR0FBVCxFQUFjLENBQWQsQ0FUWjtBQVVKYyxRQUFBQSxLQUFLLEVBQUViLE1BQU0sQ0FBQ2M7QUFWVixPQVJQO0FBb0JDQyxNQUFBQSxPQUFPLEVBQUU7QUFDUFgsUUFBQUEsTUFBTSxFQUFFLENBREQ7QUFFUEYsUUFBQUEsUUFBUSxFQUFFLFVBRkg7QUFHUE0sUUFBQUEsSUFBSSxFQUFFVCxPQUFPLENBQUMsR0FBRCxDQUhOO0FBSVBVLFFBQUFBLEdBQUcsRUFBRVYsT0FBTyxDQUFDLENBQUQsQ0FKTDtBQUtQaUIsUUFBQUEsS0FBSyxFQUFFakIsT0FBTyxDQUFDLEdBQUQsQ0FMUDtBQU1Qa0IsUUFBQUEsTUFBTSxFQUFFbEIsT0FBTyxDQUFDLEdBQUQ7QUFOUixPQXBCVjtBQTRCQ21CLE1BQUFBLElBQUksRUFBRTtBQUNKQyxRQUFBQSxTQUFTLEVBQUUsVUFEUDtBQUVKQyxRQUFBQSxRQUFRLEVBQUVyQixPQUFPLENBQUMsQ0FBRCxDQUZiO0FBR0phLFFBQUFBLE9BQU8sRUFBRWIsT0FBTyxDQUFDLENBQUQ7QUFIWjtBQTVCUCxLQURIO0FBQUEsR0FESyxFQW9DTCxDQUFDQSxPQUFELEVBQVVDLE1BQVYsQ0FwQ0ssQ0FBUDtBQXNDRCxDQXhDTTs7OztjQUFNRixTO1VBQ2lCdUIsa0I7OztBQXlDOUIsSUFBTUMsWUFBb0UsR0FBRyxTQUF2RUEsWUFBdUUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSLEVBQWdCO0FBQUEsTUFDbkZDLFFBRG1GLEdBQ0pGLEtBREksQ0FDbkZFLFFBRG1GO0FBQUEsTUFDekVDLFFBRHlFLEdBQ0pILEtBREksQ0FDekVHLFFBRHlFO0FBQUEsTUFDL0RDLFdBRCtELEdBQ0pKLEtBREksQ0FDL0RJLFdBRCtEO0FBQUEsTUFDbERDLGVBRGtELEdBQ0pMLEtBREksQ0FDbERLLGVBRGtEO0FBQUEsTUFDakNDLGNBRGlDLEdBQ0pOLEtBREksQ0FDakNNLGNBRGlDO0FBQUEsTUFDZEMsS0FEYywwQ0FDSlAsS0FESTtBQUUzRixNQUFNUSxPQUFPLEdBQUdqQyxTQUFTLEVBQXpCO0FBRUEsU0FDRTtBQUFRLElBQUEsR0FBRyxFQUFFaUMsT0FBTyxDQUFDOUI7QUFBckIsS0FBK0I2QixLQUEvQjtBQUFzQyxJQUFBLEdBQUcsRUFBRU47QUFBM0MsTUFDRSxlQUFDLG1CQUFEO0FBQVksSUFBQSxHQUFHLEVBQUVPLE9BQU8sQ0FBQzVCO0FBQXpCLEtBQXlDeUIsZUFBekMsRUFERixFQUVFLGVBQUMsYUFBRDtBQUFNLElBQUEsY0FBYyxFQUFDLFVBQXJCO0FBQWdDLElBQUEsR0FBRyxFQUFFRyxPQUFPLENBQUNoQjtBQUE3QyxLQUEwRGMsY0FBMUQsR0FDR0osUUFESCxhQUNHQSxRQURILGNBQ0dBLFFBREgsR0FFSSw4Q0FDRSxlQUFDLGtCQUFEO0FBQVcsbUJBQVksTUFBdkI7QUFBOEIsSUFBQSxHQUFHLEVBQUVNLE9BQU8sQ0FBQ3pCO0FBQTNDLElBREYsRUFFRSxlQUFDLGFBQUQ7QUFBTSxJQUFBLEVBQUUsRUFBRSxDQUFDb0I7QUFBWCxLQUNFLGVBQUMseUJBQUQ7QUFBa0IsSUFBQSxHQUFHLEVBQUVLLE9BQU8sQ0FBQ2IsSUFBL0I7QUFBcUMsbUJBQVksTUFBakQ7QUFBd0QsSUFBQSxPQUFPLEVBQUVTO0FBQWpFLEtBQ0UsZUFBQyxhQUFEO0FBQU0sSUFBQSxFQUFFLEVBQUVLLGVBQVY7QUFBa0IsSUFBQSxLQUFLLEVBQUMsU0FBeEI7QUFBa0MsSUFBQSxJQUFJLEVBQUU7QUFBeEMsSUFERixDQURGLENBRkYsQ0FGSixDQUZGLENBREY7QUFpQkQsQ0FyQkQ7O2NBQU1WLFk7VUFFWXhCLFM7OztlQXFCSCx1QkFBV3dCLFlBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFqRUZ4QixTOzBCQTBDUHdCLFkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgSFRNTFByb3BzLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcywgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IEZhZGUgZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUvRmFkZSc7XG5cbmltcG9ydCBGbGV4LCB7IEZsZXhQcm9wcyB9IGZyb20gJy4uL0ZsZXgnO1xuaW1wb3J0IEdvam9iTG9nbyBmcm9tICcuLi9Hb2pvYkxvZ28nO1xuaW1wb3J0IEljb24gZnJvbSAnLi4vSWNvbic7XG5pbXBvcnQgQnVyZ2VyIGZyb20gJy4uL0ljb25zL0J1cmdlcic7XG5pbXBvcnQgQmFja2dyb3VuZCBmcm9tICcuL0JhY2tncm91bmQnO1xuXG5pbXBvcnQgdXNlVGhlbWUgZnJvbSAnLi4vc3R5bGVzL3VzZVRoZW1lJztcbmltcG9ydCBUb3VjaGFibGVPcGFjaXR5IGZyb20gJy4uL1RvdWNoYWJsZU9wYWNpdHknO1xuXG5leHBvcnQgaW50ZXJmYWNlIE1vYmlsZUhlYWRlclByb3BzIGV4dGVuZHMgSFRNTFByb3BzPEhUTUxFbGVtZW50PiB7XG4gIG9uTWVudUNsaWNrPzogKCkgPT4gdm9pZDtcbiAgaGlkZU1lbnU/OiBib29sZWFuO1xuICBCYWNrZ3JvdW5kUHJvcHM/OiBTVkdQcm9wczxTVkdTVkdFbGVtZW50PjtcbiAgY29udGFpbmVyUHJvcHM/OiBGbGV4UHJvcHM8J2Rpdic+O1xufVxuXG5leHBvcnQgY29uc3QgdXNlU3R5bGVzID0gKCkgPT4ge1xuICBjb25zdCB7IHNwYWNpbmcsIGNvbG9ycyB9ID0gdXNlVGhlbWUoKTtcbiAgcmV0dXJuIHVzZU1lbW8oXG4gICAgKCkgPT5cbiAgICAgICh7XG4gICAgICAgIHJvb3Q6IHtcbiAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgfSxcbiAgICAgICAgYmFja2dyb3VuZDoge1xuICAgICAgICAgIHpJbmRleDogMCxcbiAgICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICB9LFxuICAgICAgICBsb2dvOiB7XG4gICAgICAgICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gICAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgICAgbGVmdDogJzUwJScsXG4gICAgICAgICAgdG9wOiAnNTAlJyxcbiAgICAgICAgICB0cmFuc2Zvcm06ICd0cmFuc2xhdGUoLTUwJSwgLTUwJSknLFxuICAgICAgICAgIGhlaWdodDogJzEwMCUnLFxuICAgICAgICAgIHdpZHRoOiAnYXV0bycsXG4gICAgICAgICAgLy8gQmlnZ2VyIGJvdHRvbSBzcGFjaW5nIGlzIG5lZWRlZCB0byBtYW5hZ2UgdGhlIGJvdHRvbSBzaGFkb3cgb2YgdGhlIGRyYXdlclxuICAgICAgICAgIHBhZGRpbmc6IHNwYWNpbmcoMS41LCAwLCAzLjUsIDApLFxuICAgICAgICAgIGNvbG9yOiBjb2xvcnMucHJpbWFyeSxcbiAgICAgICAgfSxcbiAgICAgICAgY29udGVudDoge1xuICAgICAgICAgIHpJbmRleDogMSxcbiAgICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgICAgICBsZWZ0OiBzcGFjaW5nKDAuNSksXG4gICAgICAgICAgdG9wOiBzcGFjaW5nKDEpLFxuICAgICAgICAgIHJpZ2h0OiBzcGFjaW5nKDAuNSksXG4gICAgICAgICAgYm90dG9tOiBzcGFjaW5nKDAuNSksXG4gICAgICAgIH0sXG4gICAgICAgIG1lbnU6IHtcbiAgICAgICAgICBhbGlnblNlbGY6ICdiYXNlbGluZScsXG4gICAgICAgICAgbWluV2lkdGg6IHNwYWNpbmcoNCksXG4gICAgICAgICAgcGFkZGluZzogc3BhY2luZygxKSxcbiAgICAgICAgfSxcbiAgICAgIH0gYXMgY29uc3QpLFxuICAgIFtzcGFjaW5nLCBjb2xvcnNdXG4gICk7XG59O1xuXG5jb25zdCBNb2JpbGVIZWFkZXI6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8SFRNTEVsZW1lbnQsIE1vYmlsZUhlYWRlclByb3BzPiA9IChwcm9wcywgcmVmKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGhpZGVNZW51LCBvbk1lbnVDbGljaywgQmFja2dyb3VuZFByb3BzLCBjb250YWluZXJQcm9wcywgLi4ub3RoZXIgfSA9IHByb3BzO1xuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8aGVhZGVyIGNzcz17Y2xhc3Nlcy5yb290fSB7Li4ub3RoZXJ9IHJlZj17cmVmfT5cbiAgICAgIDxCYWNrZ3JvdW5kIGNzcz17Y2xhc3Nlcy5iYWNrZ3JvdW5kfSB7Li4uQmFja2dyb3VuZFByb3BzfSAvPlxuICAgICAgPEZsZXgganVzdGlmeUNvbnRlbnQ9XCJmbGV4LWVuZFwiIGNzcz17Y2xhc3Nlcy5jb250ZW50fSB7Li4uY29udGFpbmVyUHJvcHN9PlxuICAgICAgICB7Y2hpbGRyZW4gPz8gKFxuICAgICAgICAgIDw+XG4gICAgICAgICAgICA8R29qb2JMb2dvIGRhdGEtdGVzdGlkPVwiTG9nb1wiIGNzcz17Y2xhc3Nlcy5sb2dvfSAvPlxuICAgICAgICAgICAgPEZhZGUgaW49eyFoaWRlTWVudX0+XG4gICAgICAgICAgICAgIDxUb3VjaGFibGVPcGFjaXR5IGNzcz17Y2xhc3Nlcy5tZW51fSBkYXRhLXRlc3RpZD1cIk1lbnVcIiBvbkNsaWNrPXtvbk1lbnVDbGlja30+XG4gICAgICAgICAgICAgICAgPEljb24gYXM9e0J1cmdlcn0gY29sb3I9XCJwcmltYXJ5XCIgc2l6ZT17Nn0gLz5cbiAgICAgICAgICAgICAgPC9Ub3VjaGFibGVPcGFjaXR5PlxuICAgICAgICAgICAgPC9GYWRlPlxuICAgICAgICAgIDwvPlxuICAgICAgICApfVxuICAgICAgPC9GbGV4PlxuICAgIDwvaGVhZGVyPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihNb2JpbGVIZWFkZXIpO1xuIl19